import axios, { AxiosRequestConfig } from "axios";
import { trace as startTrace } from "firebase/performance";
import { perf } from "../../utils/firebase";

export const getSelfie = async (gti: string | null, atgId: string | null) => {
  if (!gti) return undefined;

  const url = `${process.env.REACT_APP_GCP_BASE_URL}/agr/api/hair/v1/selfies?gti=${gti}&profileId=${atgId}&page=1&pageSize=6`;
  const axiosConfig: AxiosRequestConfig = {
    url: url,
    method: "GET",
    params: null,
    headers: {
      "x-api-key": process.env.REACT_APP_GCP_API_KEY,
      "Content-Type": "application/json",
    },
  };

  const trace = startTrace(perf, `Api call: ${url}`);
  trace.start();

  try {
    const response = await axios(axiosConfig);
    return response;
  } catch (error) {
    throw error;
  } finally {
  }
};

export const uploadSelfie = async (formData: FormData | null) => {
  const url = `${process.env?.REACT_APP_GCP_BASE_URL}/agr/api/hair/v4/selfies`;
  const trace = startTrace(perf, `Api call: ${url}`);
  try {
    if (!formData) return undefined;
    const axiosConfig: AxiosRequestConfig = {
      url: url,
      method: "POST",
      params: null,
      data: formData,
      headers: {
        "x-api-key": process.env?.REACT_APP_GCP_API_KEY,
        "Content-Type": "multipart/form-data",
      },
    };

    trace.start();

    const response = await axios(axiosConfig);
    return response;
  } catch (error: any) {
    console.log("error: ", error);
    throw error;
  } finally {
    trace.stop();
  }
};

export const saveSelfie = async (selfieId: string | null) => {
  if (!selfieId) return undefined;
  const url = `${process.env.REACT_APP_GCP_BASE_URL}/agr/api/hair/v1/selfies/${selfieId}`;
  const axiosConfig: AxiosRequestConfig = {
    url: url,
    method: "PATCH",
    params: null,
    data: { profile: true },
    headers: {
      "x-api-key": process.env.REACT_APP_GCP_API_KEY,
      "Content-Type": "application/json",
    },
  };

  const trace = startTrace(perf, `Api call: ${url}`);
  trace.start();

  try {
    const response = await axios(axiosConfig);
    return response;
  } catch (error) {
    throw error;
  } finally {
    trace.stop();
  }
};

export const aceptTerms = async (
  gti: string | undefined,
  atgId: string | undefined
) => {
  const url = `${process.env.REACT_APP_GCP_BASE_URL}/agr/api/hair/v1/terms`;
  const axiosConfig: AxiosRequestConfig = {
    url: url,
    method: "POST",
    data: {
      gti: gti ?? "",
      operation: "terms",
      client: "hair",
      accepted: "true",
      userId: atgId ?? "",
    },
    headers: {
      "x-api-key": process.env.REACT_APP_GCP_API_KEY,
      "Content-Type": "application/json",
    },
  };

  const trace = startTrace(perf, `Api call: ${url}`);
  trace.start();

  try {
    const response = await axios(axiosConfig);
    return response;
  } catch (error) {
    throw error;
  } finally {
    trace.stop();
  }
};
